const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/$id.overview.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getNearestVersionDate } from '@common*';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/venues/$id/overview')({
  beforeLoad: async ({
    context: {
      overviewVersions
    },
    params,
    matches
  }) => {
    const lastMatch = matches[matches.length - 1];
    if (!lastMatch.id.endsWith(`/venues/${params.id}/overview`)) return;
    const latestVersion = getNearestVersionDate(overviewVersions);
    if (!latestVersion) {
      redirect({
        to: '/venues/$id/general',
        params: {
          id: params.id
        },
        throw: true,
        replace: true
      });
    } else {
      redirect({
        to: '/venues/$id/overview/$version',
        params: {
          id: params.id,
          version: latestVersion
        },
        throw: true,
        replace: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});